<template>
  <div>
    <AdminMenu />

    <el-card class="m-2">
      <div slot="header">
        <h3 class="m-0">Proof of concept: Optimizer Input</h3>
      </div>

      <el-row :gutter="20">
        <el-col :span="12">

          <h4>Async getters</h4>
          <pre class="mini-pre">my_async_data1: {{my_async_data1}}</pre>
          <pre class="mini-pre">my_async_data2: {{my_async_data2}}</pre>
          <pre class="mini-pre">my_async_data3: {{my_async_data3}}</pre>

          <el-button-group>
            <el-button @click="my_state_1++" size="mini">Change 1</el-button>
            <el-button @click="my_state_2++" size="mini">Change 2</el-button>
            <el-button @click="my_state_3++" size="mini">Change 3</el-button>
            <el-button @click="onInfo" size="mini">i</el-button>
          </el-button-group>

        </el-col>
        <el-col :span="12">

          ...

        </el-col>
      </el-row>

    </el-card>
  </div>
</template>

<script>
import AdminMenu from './Elements/AdminMenu'
// import { fake_models, fake_db } from './Elements/VuexProofOfConcept'

export default {
  data: () => ({
    my_state_1: 1,
    my_state_2: 100,
    my_state_3: 1000,
  }),
  created() {
  },
  computed: {
    /*
    my_async_data1() {
      console.log("my_async_data1")
      console.log("this.my_state_1", this.my_state_1)
      if ( Math.random() > 0.5 ) {
        console.log("this.my_state_2", this.my_state_2)
      }
      return 'foo'
    },
    my_async_data2() {
      console.log("my_async_data2")
      return new Promise((resolve, reject) => {
        setTimeout(() => resolve('foo'), 1000)
      })
    },
    my_async_data3() {
      console.log("my_async_data3")
      setTimeout(() => {
        console.log("my_async_data3:timeout", this.my_state_3);
      }, 100)
      return 'foo'
    },
    */
    my_async_data1: () => 'A1',
    my_async_data2: () => 'A2',
    my_async_data3: () => 'A3',
  },
  methods: {
    onInfo() {
      console.clear();
      // this.$watch('my_state_1', function (newVal, oldVal) {
      // })
      // console.log( "_data", Vue.pursue( this._data ) );
      // 1 = getter my_async_data1
      console.log( "_watchers", this._watchers[1].deps[0].subs );
      console.log( "_watchers", this._watchers[1].deps[1] );
      // console.log( "my_state_1", Vue.pursue( this.my_state_1 ) );
      // console.log( "my_state_1", Vue.pursue(() => this.my_state_1 ) );
      // console.log( "my_async_data1", Vue.pursue( this.my_async_data1 ) );
    }
  },
  components: {
    AdminMenu
  }
};
</script>
